<template>
    <div class="prospus-tooltip-wrapper">
        <div class="prospus-tooltip-wrapper__arrow"></div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "Tooltip",
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_theme-variables.sass";
.prospus-tooltip-wrapper {
    background-color: $secondary !important;
    color: $fontLight !important;
    .prospus-tooltip-wrapper__arrow {
        border-bottom: none !important;
        border-right: none !important;
        background-color: $secondary !important;
    }
}
</style>
